<template>
  <div class="t-lk-success" :class="props.class">
    <h3 v-if="props.title" class="t-lk-modal__title t-lk-success__title">{{ props.title }}</h3>
    <div v-if="props.text" class="t-lk-success__text" v-html="props.text"></div>
    <div @click="modalClose" class="t-lk-success__btn t-btn _green _lk">
      {{ $root.staticText.lk.lkModalBtn }}
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: ['props'],
  methods: {
    ...mapActions('modal', ['modalClose']),
  },
}
</script>

<style lang="sass"></style>



// WEBPACK FOOTER //
// src/templates/components/base/modals/lk-success.vue